const cookie = require('cookie');
module.exports = cookie;